<template>
  <div>
    <el-alert
      type="info"
      title="Under Development"
      description="Still in beta, not everything works (yet)."
      show-icon />

    <el-row v-if="site">
      <el-col :span="8">
        <strong class="text-muted">{{utilLabel}} Address</strong>
        <el-col :span="24" v-if="site.tenancy && site.tenancy.utilAddress">
          <i class="text-muted">{{site.tenancy.utilAddress}}</i>
        </el-col>
        <el-col :span="24" v-else>
          <i class="text-muted">No {{utilLabel}} address found</i>
        </el-col>
      </el-col>
      </el-col>

      <el-col :span="8">
        <el-steps :active="actionData.currentStep" :space="100" finish-status="success">
          <el-step title="Summary"></el-step>
          <el-step :title="actionData.steps[0].stepName"></el-step>
          <el-step :title="actionData.steps[1].stepName"></el-step>
          <el-step :title="actionData.steps[2].stepName"></el-step>
          <el-step :title="actionData.steps[3].stepName"></el-step>
        </el-steps>
       </el-col>

       <el-col :span="8">
         <strong class="text-muted">Site Address</strong>
         <el-col :span="24" v-if="site.address">
           <i class="text-muted">{{site.address}}</i>
         </el-col>
         <el-col :span="24" v-else>
           <i class="text-muted">No address found</i>
         </el-col>
         <el-col :span="24">
           <span class="text-muted" v-if="site.subdistrict">{{site.subdistrict}}&nbsp;</span>
           <span class="text-muted" v-if="site.district">{{site.district}}&nbsp;</span>
           <span class="text-muted" v-if="site.region">{{site.region}}&nbsp;</span>
           <span class="text-muted" v-if="site.state">{{site.state}}&nbsp;</span>
         </el-col>

       </el-col>
     </el-row>


      <el-tabs v-model="step" type="border-card" @tab-click="tabClicked" stretch>

       <el-tab-pane name="summary">
         <template #label><span><i class="fa fa-list"></i> Summary</span></template>

        <center><h2>Summary</h2></center>

        <kanban-board :title="actionData.steps[0].stepName" v-model="actionData.steps[0].state" />

        <kanban-board :title="actionData.steps[1].stepName" v-model="actionData.steps[1].state" />

        <kanban-board :title="actionData.steps[2].stepName" v-model="actionData.steps[2].state" />

        <kanban-board :title="actionData.steps[3].stepName" v-model="actionData.steps[3].state" />

      </el-tab-pane>


        <el-tab-pane name="step1">
          <template #label><span><i :class="actionData.steps[0].stepIcon"></i> {{actionData.steps[0].stepName}}</span></template>
          <center><h2>{{actionData.steps[0].stepName}}</h2></center>
          <progress-step1  :site-id="actionData.id" :row-data="actionData" :step-data="actionData.steps[0]" />
        </el-tab-pane>

        <el-tab-pane name="step2" lazy>
          <template #label><span><i :class="actionData.steps[1].stepIcon"></i> {{actionData.steps[1].stepName}}</span></template>
          <center><h2>{{actionData.steps[1].stepName}}</h2></center>
          <progress-step2 :site-id="actionData.id" :row-data="actionData" :step-data="actionData.steps[1]" />
        </el-tab-pane>

        <el-tab-pane name="step3" lazy>
          <template #label><span><i :class="actionData.steps[2].stepIcon"></i> {{actionData.steps[2].stepName}}</span></template>
          <center><h2>{{actionData.steps[2].stepName}}</h2></center>
          <progress-step3 :site-id="actionData.id" :row-data="actionData"  :step-data="actionData.steps[2]" />
        </el-tab-pane>

        <el-tab-pane name="step4" lazy>
          <template #label><span><i :class="actionData.steps[3].stepIcon"></i> {{actionData.steps[3].stepName}}</span></template>
          <center><h2>{{actionData.steps[3].stepName}}</h2></center>
          <progress-step4 :site-id="actionData.id" :row-data="actionData"  :step-data="actionData.steps[3]" />
        </el-tab-pane>

        <el-tab-pane lazy>
          <template #label><span><i class="fa fa-home"></i> Land Owner</span></template>
          <el-row>
            <el-col :span="14">
              <h2>Land Owner</h2>

              <div v-if="!hasLandowner(site)">
                <center>
                  <h3 class="subtitle">No landowner information found</h3>
                </center>
              </div>
              <div v-else>
                <el-row>
                  <el-col :span="4">
                    Owner
                  </el-col>

                  <el-col :span="20">
                    <strong>{{site.tenancy.owner.name}}</strong>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="4">
                    Address
                  </el-col>
                  <el-col :span="20">
                    <strong>{{site.tenancy.owner.address}}</strong>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="4">
                    Post Code
                  </el-col>
                  <el-col :span="20">
                    <strong>{{site.tenancy.owner.postCode}}</strong>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="4">
                    Phone
                  </el-col>
                  <el-col :span="20">
                    <strong>{{site.tenancy.owner.phone}}</strong>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="4">
                    e-Mail
                  </el-col>
                  <el-col :span="20">
                    <strong>{{site.tenancy.owner.email}}</strong>
                  </el-col>
                </el-row>

              </div>
<!--
              <br />

              <table v-if="site.landStarted" class="el-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Date</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tfoot>
                </tfoot>
                <tbody>
                  <tr>
                    <td>{{site.landType}} Agreement</td>
                    <td><strong :class="isOverdue(site.landExpiry) ? 'text-primary' : 'text-success'">{{formatDate(site.landStarted)}}</strong></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Deposit Paid</td>
                    <td></td>
                    <td>{{formatNumber(site.landDeposit)}}</td>
                  </tr>
                  <tr>
                    <td>{{site.frequency}} Rental</td>
                    <td></td>
                    <td>{{formatNumber(site.landPayment)}}</td>
                  </tr>
                  <tr>
                    <td>Agreement Expiry</td>
                    <td><strong :class="isOverdue(site.landExpiry) ? 'text-warning' : 'text-primary'">{{formatDate(site.landExpiry)}}</strong> <i>({{formatFriendlyDate(site.landExpiry)}})</i></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Renewal Increment</td>
                    <td>
                      <span v-if="site.term">
                        <strong>{{site.term}}</strong>
                        {{site.term > 1 ? 'times' : 'time'}}
                      </span>
                    </td>
                    <td><strong>{{formatNumber(site.renewalIncrement)}}</strong> %</td>
                  </tr>
                </tbody>
              </table>
-->
            </el-col>

      </el-row>
    </el-tab-pane>


      </el-tabs>

  </div>

</template>


<script>

import PermitMixins from '@/mixins/PermitMixins'

import {settings} from '@/components/Data'

import KanbanBoard from '@/components/atoms/KanbanBoard'

import ProgressStep1 from '@/components/progress/ProgressStep1'
import ProgressStep2 from '@/components/progress/ProgressStep2'
import ProgressStep3 from '@/components/progress/ProgressStep3'
import ProgressStep4 from '@/components/progress/ProgressStep4'

export default {
  mixins: [PermitMixins],

  components: {
    KanbanBoard,
    ProgressStep1,
    ProgressStep2,
    ProgressStep3,
    ProgressStep4,
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  methods: {
    tabClicked (tab) {
      this.actionData.currentStep = Number(tab.index)
//      this.getData(this.actionData.currentStep)
    },

    close () {
//      console.log('Hello! I\'m your friendly CLOSE action! ')
    },

    reset () {
//      console.log('Hello! I\'m your friendly RESET action! ')
    },

    // XOL-596: `save` / `saveProgress` (a whole-row PUT /actions that sent
    // `currentStep` and `status`) are gone. They were unreachable anyway:
    // ProgressWorkflowAction asked `$refs.permits` for them while its ref is
    // `Progress`. The progress steps save themselves (ProgressStepMixins), and
    // `currentStep` / `status` change only on the server.

    found (siteFound) {
      this.site = siteFound
    },

    getData (step) {
      if (step && typeof step === 'number') {
        step = step + 1
      } else {
        return
      }

      if (this.isEmptyObject(this['step' + step + 'Data']) && this.rowData) {
        this.fetchData('/step/' + this.actionData.id + '/' + step, this['receive' + step])
      }

    }
  },

  data () {
    return {
      site: null,
      step: this.rowData.currentStep ? '' + this.rowData.currentStep : 0,
      permitLabel: settings.permitLabel,
      utilLabel: this.getUtilLabel(this.rowData),
      actionData: this.rowData
    }
  },

  created () {
    this.findSite(this.rowData.site_id, this.found)

    if (!this.actionData.summary) {
      this.actionData.status = 'New Submission'
    }

    if (!this.actionData.currentStep) {
      this.actionData.currentStep = 0
    }

    if (!this.actionData.state) {
      this.actionData.state = {}
    }

    if (!this.actionData.state.application) {
      this.actionData.state.application = this.application
    }

    if (!this.actionData.state.submission) {
      this.actionData.state.submission = this.submission
    }

    if (!this.actionData.state.renewal) {
      this.actionData.state.renewal = this.renewal
    }

//    console.log('actionData', this.actionData)
  }
}

</script>
